import { useMemo } from 'react';
import { GridRowModel, useGridApiRef } from '@enterprise/material-data-grid';
import { ItemSheetRequestIndexes } from '../ImportSelectHeaders';
import { useAnimanaImportGridColumns } from './useAnimanaImportGridColumns.hook';
import { useImportGridColumns } from './useImportGridColumns.hook';
import { ImportRowModel } from '../../../../core/models';
import { ScreenSizeType, useScreenSize } from '../../../../hooks';
import styles from '../../../userManagement/usersGrid/usersGrid.module.scss';

export type ImportGridRow = ImportRowModel & { id: number };

export interface UseImportGridProps {
    isAnimanaOnly: boolean;
    animanaIndexes?: ItemSheetRequestIndexes | null;
    excludedFields?: string[];
}

const headerSize = new Map<ScreenSizeType, string>([
    [ScreenSizeType.xs, styles.headerXs],
    [ScreenSizeType.sm, styles.headerSm],
    [ScreenSizeType.md, styles.headerMd],
    [ScreenSizeType.lg, styles.headerLg],
    [ScreenSizeType.xl, styles.headerXl],
]);

export const useImportGrid = ({ isAnimanaOnly, animanaIndexes, excludedFields }: UseImportGridProps) => {
    const { screenSize } = useScreenSize();
    const apiRef = useGridApiRef();
    const { columns: defaultColumns } = useImportGridColumns();
    const { animanaColumns } = useAnimanaImportGridColumns({ indexes: animanaIndexes, excludedFields });

    const columns = useMemo(() => {
        return isAnimanaOnly ? animanaColumns : defaultColumns;
    }, [animanaColumns, defaultColumns, isAnimanaOnly]);

    const getRowId = (row: GridRowModel): string => String((row as ImportGridRow).id);

    return {
        apiRef,
        columns,
        getRowId,
        headerHeight: Number(headerSize.get(screenSize)),
    };
};
